<h2 mat-dialog-title>{{tituloTxt}}</h2>
<mat-dialog-content style="min-width: 400px; min-height: 100px;">
  <form [formGroup]="registerForm" (ngSubmit)="guardar()" class="example-form">
    <mat-form-field appearance="outline" class="example-full-width">
      <mat-label>Razon social</mat-label>
      <input
        formControlName="razonSocial"
        matInput
        placeholder="Razon social del club"
        value=""
      />
      <mat-error>La razon social es requerida</mat-error>
    </mat-form-field>
    <input type="hidden" formControlName="id" value="" />

    <mat-form-field appearance="outline" class="example-full-width">
      <mat-label>Correo electrónico</mat-label>
      <input
        formControlName="email"
        matInput
        placeholder="Correo electrónico del club"
        value=""
      />
      <mat-error>El correo electronico es requerido o no es valido</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="example-full-width">
      <mat-label>Dirección</mat-label>
      <input
        formControlName="direccion"
        matInput
        placeholder="Direccion del club"
        value=""
      />

    </mat-form-field>

    <mat-form-field appearance="outline" class="example-full-width">
      <mat-label>telefono</mat-label>
      <input
        formControlName="telefono"
        matInput
        placeholder="Telefono del club"
        value=""
      />
    </mat-form-field>

    <mat-form-field appearance="outline" class="example-full-width">
      <mat-label>Celular</mat-label>
      <input
        formControlName="celular"
        matInput
        placeholder="Numero de celular del club"
        value=""
      />
    </mat-form-field>


    <div class="example-full-width">
      <mat-slide-toggle class="example-margin" formControlName="estado">
        Estado
      </mat-slide-toggle>
    </div>
  </form>


</mat-dialog-content>
<mat-dialog-actions>
  <button
    type="submit"
    mat-button
    mat-flat-button
    color="primary"
    (click)="guardar()"
    [disabled]="registerForm.invalid"
  >
    Guardar
  </button>
  <button mat-button mat-dialog-close="false">Cancelar</button>
</mat-dialog-actions>

<!-- mat-dialog-close='false' -->
